"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const vue_3 = require("vue");
const RolesListTable_vue_1 = __importDefault(require("./RolesListTable.vue"));
const roles_js_1 = require("../../js/roles.js");
const role_requests_js_1 = require("../../js/role_requests.js");
const errors_js_1 = __importDefault(require("../../js/errors.js"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'RolesListPage',
    props: {
        roles: {
            type: Array,
            required: true,
        },
        isGroupRolePage: {
            type: Boolean,
            required: true,
        },
        isGroupOwner: {
            type: Boolean,
            required: true,
        },
        numOfBranches: {
            type: Number,
            required: true,
        },
    },
    setup(__props, { expose: __expose }) {
        const props = __props;
        const roles = (0, vue_3.ref)(props.roles);
        const selectedRoleId = (0, vue_3.ref)(0);
        const rolesOnlyList = (0, vue_3.computed)(() => roles.value.filter(role => !role.IsRoleSection));
        const roleList = (0, vue_3.computed)(() => {
            if (props.isGroupRolePage) {
                return rolesOnlyList.value.filter(role => role.GroupWide && role.ID !== selectedRoleId.value);
            }
            return rolesOnlyList.value;
        });
        function openRoleModalEdit(roleId) {
            selectedRoleId.value = roleId;
            (0, roles_js_1.openRoleFormEdit)(roleId);
        }
        function setActiveBranchCountForRole(roleId, activeBranchCount) {
            const role = roles.value.find(r => r.ID === roleId);
            if (!role) {
                return;
            }
            const count = activeBranchCount ?? props.numOfBranches;
            role.ActiveBranchCount = count === props.numOfBranches ? "全拠点" : (count > 0 ? count : "なし");
        }
        function setShowCount(roleId, value) {
            const role = roles.value.find(r => r.ID === roleId);
            if (!role) {
                return;
            }
            role.ShowCount = value;
        }
        function setShowStaffCount(roleId, value) {
            const role = roles.value.find(r => r.ID === roleId);
            if (!role) {
                return;
            }
            role.ShowStaffCount = value;
        }
        function handleUpdateShowCount(role, checked) {
            (0, roles_js_1.updateShowCount)(role, checked, props.isGroupRolePage, props.isGroupOwner);
        }
        function handleUpdateShowStaffCount(role, checked) {
            (0, roles_js_1.updateShowStaffCount)(role, checked, props.isGroupRolePage, props.isGroupOwner);
        }
        async function handleUpdatePosition(oldIndex, newIndex) {
            if (oldIndex === newIndex) {
                return;
            }
            const previousOrder = roles.value.slice();
            const movedRole = roles.value.splice(oldIndex, 1)[0];
            if (!movedRole) {
                return;
            }
            roles.value.splice(newIndex, 0, movedRole);
            const roleIds = roles.value.map(r => r.ID);
            try {
                const response = await (0, role_requests_js_1.moveRoleRequest)(roleIds);
                if (!response.success) {
                    roles.value = previousOrder;
                    (0, roles_js_1.openAlertModal)(errors_js_1.default.ROLE.UPDATE, true);
                }
            }
            catch {
                roles.value = previousOrder;
                (0, roles_js_1.openAlertModal)(errors_js_1.default.ROLE.UPDATE, true);
            }
        }
        __expose({
            roles,
            selectedRoleId,
            setActiveBranchCountForRole,
            setShowCount,
            setShowStaffCount,
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(RolesListTable_vue_1.default, {
                roles: roleList.value,
                "is-group-role-page": __props.isGroupRolePage,
                onEditRole: openRoleModalEdit,
                onUpdatePosition: handleUpdatePosition,
                onUpdateShowCount: handleUpdateShowCount,
                onUpdateShowStaffCount: handleUpdateShowStaffCount
            }, null, 8 /* PROPS */, ["roles", "is-group-role-page"]));
        };
    }
});
